import { render, staticRenderFns } from "./ShowArchivedSwitch.vue?vue&type=template&id=3c70781b"
import script from "./ShowArchivedSwitch.vue?vue&type=script&lang=js"
export * from "./ShowArchivedSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports